<template>
  <wallet-form-shell>
    <wallet-form
      ref="loginForm"
      :form-type="formType"
      :loading="loading"
      @form-submit="recipientLogin"
    />
    <p>
      <router-link :to="recoverPasswordRoute">
        {{ $t('wallet.login.footer-forgot-password-link-text') }}
      </router-link>
    </p>
    <i18n
      path="wallet.login.footer-register-text"
      tag="p"
    >
      <router-link :to="registerRoute">
        {{
          $t('wallet.login.footer-register-link-text')
        }}
      </router-link>
    </i18n>
  </wallet-form-shell>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import WalletFormShell from '@/components/wallet/WalletFormShell'
import WalletForm from '@/components/wallet/WalletForm'
import { WalletFormType } from '@/components/wallet/wallet-form-type'
import {
  WALLET_REGISTER_ROUTE,
  WALLET_FORGOT_ROUTE,
  WALLET_DASHBOARD
} from '@/router/routes/route-names'
import { LOGIN } from '@/store/action-types'
import { GET_IS_AUTHENTICATED } from '@/store/get-types'
import { HttpClient } from '@/cowboy/http/HttpClient'

export default {
  name: 'Login',
  components: {
    WalletFormShell,
    WalletForm
  },
  data: () => ({
    loading: false
  }),
  computed: {
    ...mapGetters({
      isAuthenticated: GET_IS_AUTHENTICATED
    }),
    formType () {
      return WalletFormType.LOGIN
    },
    registerRoute () {
      return { name: WALLET_REGISTER_ROUTE }
    },
    recoverPasswordRoute () {
      return { name: WALLET_FORGOT_ROUTE }
    }
  },
  created () {
    if (this.isAuthenticated) {
      this.$router.push({ name: WALLET_DASHBOARD })
    }
  },
  methods: {
    ...mapActions({
      login: LOGIN
    }),
    async recipientLogin ({ emailAddress, password }) {
      this.loading = true
      try {
        await this.login({ emailAddress, password })
        await this.$router.push({ name: WALLET_DASHBOARD })
      } catch (e) {
        console.error(e)
        HttpClient.handleHttpError({
          errorTitle: this.$t('wallet.login.error.title'),
          errorBody: this.$t('wallet.login.error.message'),
          timeout: 10000 // 10 seconds
        })
        this.$refs.loginForm.resetForm()
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
